// ─────────────────────────────────────────────────────────────────────────────
// Ignore Codes Selectors
// ─────────────────────────────────────────────────────────────────────────────
// NgRx selectors for the ignoreCodes store slice.
// ─────────────────────────────────────────────────────────────────────────────

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IgnoreCodesState } from './ignore-codes.reducers';

// ── Feature selector ─────────────────────────────────────────────────────────

export const selectIgnoreCodes = createFeatureSelector<IgnoreCodesState>('ignoreCodes');

// ── Basic selectors ──────────────────────────────────────────────────────────

export const selectIgnoreCodeItems = createSelector(selectIgnoreCodes, (state) => state.ignoreCodes);
export const selectIgnoreCodeMetadata = createSelector(selectIgnoreCodes, (state) => state.metadata);
export const selectIgnoreCodeLoading = createSelector(selectIgnoreCodes, (state) => state.loading);
export const selectIgnoreCodeCreating = createSelector(selectIgnoreCodes, (state) => state.creating);
export const selectIgnoreCodeUpdating = createSelector(selectIgnoreCodes, (state) => state.updating);
export const selectIgnoreCodeKeyword = createSelector(selectIgnoreCodes, (state) => state.keyword);
export const selectIgnoreCodeFilters = createSelector(selectIgnoreCodes, (state) => state.filters);
